import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

export interface AboutPageContent {
  hero: NarrativeHeroProps
  fifties: FiftyFiftyProps[]
}

interface FiftyFiftyTextFields {
  header: string
  subHeader: string
  image: string
  body: React.ReactNode
  button?: {
    text: string
    link?: {
      href: string
    }
    action?: 'booking-widget-redirect'
  }
}

const commonFiftyFiftyProps = {
  backgroundColor: 'grey' as 'white' | 'grey',
  showEyebrow: false,
}

const BACKGROUND_IMAGE = '/images/shipskis/friends-skiing.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Created by skiers for skiers.',
  subHeader: 'No lugging, no baggage lines —just relaxed winter travel from the get-go.',
}

const fiftyTexts: FiftyFiftyTextFields[] = [
  {
    header: 'Our story',
    subHeader: "Trust us, we've been there",
    image: '/images/shipskis/selfie-skier.jpg',
    button: {
      text: 'Get started',
      action: 'booking-widget-redirect',
    },
    body: (
      <>
        <p>
          We know first-hand how much of a hassle it can be traveling with your ski gear.
          That&apos;s why, in 2014, we set out to solve that problem, once and for all. Since 2011,
          our family of brands has helped our customers ship their gear over 277 million miles,
          forming partnerships with resorts, retailers, and hotels across the world. Today, we
          operate at more than 3,500 facilities worldwide.
        </p>
      </>
    ),
  },
  {
    header: 'How it works',
    subHeader: 'Shipping is easy.',
    image: '/images/shipskis/ski-luggage.jpg',
    button: {
      text: 'Get the details',
      link: {
        href: '/how-it-works',
      },
    },
    body: (
      <>
        <p>
          Place your order, pack your bag as you would for airline travel, and attach a provided
          shipping label. ShipSkis can pick up your luggage at your home, office, or resort, or you
          can drop it off at a local carrier. Your gear will be waiting for you at your destination.
        </p>
      </>
    ),
  },
  {
    header: 'What sets ShipSkis Apart',
    subHeader: 'Great value and personalized service.',
    image: '/images/shipskis/couple-skiing.jpg',
    button: {
      text: 'See more benefits',
      link: {
        href: '/guarantee',
      },
    },
    body: (
      <>
        <p>
          With ShipSkis, you not only save time at the airport, you also avoid airline baggage fees
          and the cost of renting a larger car. ShipSkis also provides an on-time guarantee,
          complimentary insurance, live tracking, and customer support staffed seven days a week by
          real people who can answer all your questions.
        </p>
      </>
    ),
  },
  {
    header: 'Beyond skis',
    subHeader: 'We ship. You arrive and enjoy.',
    image: '/images/shipskis/about-us-4.jpg',
    button: {
      text: 'Visit Ship&Play',
      link: {
        href: 'https://shipplay.com',
      },
    },
    body: (
      <>
        <p>
          People crave alternatives to traveling with unwieldy sports gear or bulky luggage,
          year-round. With that in mind,{' '}
          <a href={'https://shipsticks.com'} className="underline">
            ShipSticks
          </a>
          ,{' '}
          <a href={'https://luggagefree.com'} className="underline">
            Luggage Free
          </a>
          , and{' '}
          <a href={'https://shipcamps.com'} className="underline">
            ShipCamps{' '}
          </a>
          were launched. Along with ShipSkis, these shipping specialists are all part of{' '}
          <a href={'https://shipplay.com'} className="underline">
            Ship&Play
          </a>
          , a seamless, door-to-door shipping solution for travelers worldwide.
        </p>
      </>
    ),
  },
]

const fifties: FiftyFiftyProps[] = fiftyTexts.map((text, index) => ({
  ...text,
  image: {
    src: text.image,
    alt: text.header,
  },
  layout: index % 2 === 0 ? 'image-right' : 'image-left',
  ...commonFiftyFiftyProps,
}))

const content: AboutPageContent = {
  hero,
  fifties,
}

export default content
